export enum ManagementRoute {
  SETTINGS = 'settings',
  SURVEYS = 'surveys',
  USERS = 'users',
  ROLES = 'roles-management',
  NEW = 'new',
  EDIT = 'edit',
  CONTRACTORS = 'contractors',
  PROPERTY_MANAGERS = 'property-managers',
  RENEWAL_STRATEGY = 'renewal-strategy',
  APPLIANCES = 'appliances',
  KPI = 'kpi',
  PORTFOLIO = 'portfolio',
  VENDOR = 'vendor',
  SYSTEM = 'system',
  TURNOVER_CONFIGURATION = 'turnover-configuration',
  TEMPLATE = 'template',
  SPACE_TEMPLATE = 'space-template',
}
